// extracted by mini-css-extract-plugin
module.exports = {"tagCard":"minitag-module--tagCard--1C5-l","pd20px":"minitag-module--pd20px--38OXF","mini":"minitag-module--mini--1wale"};